export const coreUrls = JSON.parse(document.getElementById('core-urls-config').textContent);
